import React from "react";
import { Button } from "react-bootstrap";
import EraseIcon from "./svg/EraseIcon";

const EraseButton = ({ ...params }) => {
  return (
    <Button variant="outline-light border h-100" {...params}>
      <EraseIcon />
    </Button>
  );
};

export default EraseButton;
